"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const data = [
  {
    img: "/assets/imgs/works/1/6.png",
    title: "Intelligent Pricing Model for Airbnb Hosts",
    subTitle: "",
    caseStudyName: "metrix",
    url:"/case-study/intelligent-pricing-model"
  },
  {
    img: "/assets/imgs/works/1/3.png",
    title: "AI-Powered UX Optimization Tool",
    subTitle: "",
    caseStudyName: "ai-tool-optimization",
    url:"/case-study/age-of-ai"
  },
  {
    img: "/assets/imgs/works/1/5.png",
    title: "E-Commerce Grocery Application",
    subTitle: "",
    caseStudyName: "grocery",
    url: "/case-study/green-basket"
  },
  // {
  //   img: "/assets/imgs/works/1/1.jpg",
  //   title: "EverestDX Application development",
  //   subTitle: "",
  // },
  {
    img: "/assets/imgs/works/1/7.png",
    title: "Fitness Tracking Application",
    subTitle: "",
    caseStudyName: "fitness",
    url:"/case-study/fitness-tracker"
  },
];

export const CaseStudies = () => {
  const navigate = useNavigate();
  const swiperOptions = {
    modules: [Pagination, Navigation, Mousewheel],
    slidesPerView: "auto",
    spaceBetween: 80,
    mousewheel: true,

    loop: true,
    touchRatio: 0.2,
    speed: 1500,
    pagination: {
      el: ".work-crev .swiper-pagination",
      type: "progressbar",
    },

    navigation: {
      nextEl: ".work-crev .swiper-button-next",
      prevEl: ".work-crev .swiper-button-prev",
    },
  };
  const handleClick = (project) => {
    console.log("Navigating to:", project.url);
    if(project.url){
      navigate(project.url);
    }
  };
  return (
    <section className="work-crev sub-bg">
      <div className="container section-padding position-re bord-top-grd bord-bottom-grd">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">Case Studies</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Selected <span className="fw-200">Works.</span>
                </span>
              </h3>
            </div>
            <div className="ml-auto">
              <div className="swiper-arrow-control">
                <div className="swiper-button-prev">
                  <span className="ti-arrow-left"></span>
                </div>
                <div className="swiper-button-next">
                  <span className="ti-arrow-right"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="work-swiper out-right">
          <Swiper {...swiperOptions}>
            {data.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="item d-flex align-items-center">
                  <div className="cont">
                    <h6 className="sub-title main-color mb-15">UI/UX Design</h6>
                    <h2>
                      {item.title} <br /> {item.subTitle}
                    </h2>
                    <button
                      style={{
                        border: "none",
                        background: "transparent",
                        pointerEvents: "unset",
                      }}
                      className="butn-crev d-flex align-items-center mt-30"
                      onClick={() => handleClick(item)}
                    >
                      <span className="hover-this">
                        <span className="circle hover-anim">
                          <i
                            style={{ color: "#fff" }}
                            className="ti-arrow-top-right"
                          ></i>
                        </span>
                      </span>
                      <span className="text" style={{ color: "#fff" }}>
                        View Project
                      </span>
                    </button>
                  </div>
                  <div className="img">
                    <img src={item.img} alt="" className="radius-15" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
